import React from "react";
import i18next from "i18next";

import {
  DRIVER_APP_VERSION_NAME,
  DRIVER_PLAY_STORE_URL,
} from "../appVersion.js";

// REISOR_ANDROID_1_0_87_MANDATORY_UPDATE_UI_V1

export default function AppUpdateRequiredScreen({
  policy,
  checking = false,
  onRetry,
}) {
  const latestVersionName =
    String(
      policy?.latestVersionName ||
      DRIVER_APP_VERSION_NAME
    ).trim();

  const playStoreUrl =
    String(
      policy?.playStoreUrl ||
      DRIVER_PLAY_STORE_URL
    ).trim();

  const openGooglePlay = () => {
    try {
      window.location.assign(
        playStoreUrl ||
        DRIVER_PLAY_STORE_URL
      );
    } catch {
      try {
        window.open(
          DRIVER_PLAY_STORE_URL,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {}
    }
  };

  return (
    <div
      className="
        app-shell driver-app
        bg-slate-950 text-slate-100
        flex items-center justify-center
      "
      style={{
        minHeight: "100dvh",
        paddingTop:
          "calc(24px + env(safe-area-inset-top, 0px))",
        paddingRight:
          "calc(20px + env(safe-area-inset-right, 0px))",
        paddingBottom:
          "calc(24px + env(safe-area-inset-bottom, 0px))",
        paddingLeft:
          "calc(20px + env(safe-area-inset-left, 0px))",
      }}
    >
      <div className="
        w-full max-w-md rounded-3xl
        border border-slate-700
        bg-slate-900 p-6 shadow-2xl
      ">
        <div className="mb-5 flex items-center gap-4">
          <img
            src="/icons/icon-192.png"
            alt="REISOR PRO"
            className="h-16 w-16 rounded-2xl"
          />

          <div>
            <div className="
              text-xs font-bold uppercase
              tracking-widest text-slate-400
            ">
              REISOR PRO
            </div>

            <div className="text-2xl font-black">
              {i18next.t(
                "appUpdate.title"
              )}
            </div>
          </div>
        </div>

        <p className="
          mb-4 text-sm leading-6
          text-slate-300
        ">
          {i18next.t(
            "appUpdate.description"
          )}
        </p>

        <div className="
          mb-5 rounded-2xl
          bg-slate-950/70 p-4 text-sm
        ">
          <div className="
            flex justify-between gap-4
          ">
            <span className="text-slate-400">
              {i18next.t(
                "appUpdate.currentVersion"
              )}
            </span>

            <strong>
              {DRIVER_APP_VERSION_NAME}
            </strong>
          </div>

          <div className="
            mt-2 flex justify-between gap-4
          ">
            <span className="text-slate-400">
              {i18next.t(
                "appUpdate.requiredVersion"
              )}
            </span>

            <strong>
              {latestVersionName}
            </strong>
          </div>
        </div>

        <button
          type="button"
          onClick={openGooglePlay}
          className="
            w-full rounded-2xl
            bg-emerald-500
            px-5 py-4
            text-base font-black
            text-slate-950
            active:scale-[0.99]
          "
        >
          {i18next.t(
            "appUpdate.openGooglePlay"
          )}
        </button>

        <button
          type="button"
          disabled={checking}
          onClick={onRetry}
          className="
            mt-3 w-full rounded-2xl
            border border-slate-700
            bg-slate-800
            px-5 py-3
            text-sm font-bold
            text-slate-200
            disabled:opacity-60
          "
        >
          {checking
            ? i18next.t(
                "appUpdate.checking"
              )
            : i18next.t(
                "appUpdate.checkAgain"
              )}
        </button>
      </div>
    </div>
  );
}
